import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=758185f4&scoped=true&"
import script from "./pay.vue?vue&type=script&lang=ts&"
export * from "./pay.vue?vue&type=script&lang=ts&"
import style0 from "./pay.vue?vue&type=style&index=0&id=758185f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758185f4",
  null
  
)

export default component.exports